import React, { Component } from 'react';
import { connect } from 'react-redux';
import { userActions, alertActions } from '../../_actions';
import LoadingOverlay from 'react-loading-overlay';
import ReactPaginate from 'react-paginate';
import DialogExample from "./components/DialogExample/DialogExample";
import AddLeadModal from "./components/AddLeadModal";
import AddFollowUpModal from "./components/AddFollowUpModal";
import ShowFollowUpModal from "./components/ShowFollowUpModal";
import UpdateLeadModal from "./components/UpdateLeadModal";
import { isMobile } from "react-device-detect";
import { confirmAlert } from 'react-confirm-alert';
import 'react-confirm-alert/src/react-confirm-alert.css'; // Import css
import { BiSearch } from "react-icons/bi";
import { MdAdd } from "react-icons/md";
import { BiDetail } from "react-icons/bi";
import moment from "moment";
import { MdOutlineEdit } from "react-icons/md";
import { GrAddCircle } from "react-icons/gr";
import './style.css';
import { BiArrowBack } from "react-icons/bi";
import { FaList, FaRegCopy } from "react-icons/fa6";
// import { FaRegCopy } from "react-icons/fa";
import dayjs from 'dayjs';


class Lead extends Component {
  constructor(props) {
    super(props);
    this.multiselectRef = React.createRef();
    this.multiselectRefUser = React.createRef();
    this.state = {
      selectedPage: parseInt(this.props.match.params.pageNo, 10) - 1 || 0,
      isVideo: false,
      isVideoUpdate: false,
      showFollowUpModal: false,
      // selectedTag: [""],
      selectedUser: [],
      updateSelectedUser: [],
      selectedCategory: [],
      updateSelectedCategory: [],
      selectedValue: [],
      dateAndTimeValue: "",
      userRowData: {},
      fieldsLead: {
        "calenderDate": moment(new Date()).format("YYYY-MM-DD")
      },
      errorsLead: {},
      fieldsLeadUpdate: {},
      fieldsFollowUp: {
        "dateAndTimeValue": dayjs().hour(10).minute(0)
      },
      errorsFollowUp: {},
      fieldsUserPasswordUpdate: {},
      errorsUpdateLead: {},
      errorsUpdatePassword: {},
      viewRowData: {},
      type: null,
      gameType: null,
      rankType: null,
      addQuoteModal: false,
      moreDetailsCreateModal: false,
      updateLeadModal: false,
      loginToThisAccountModal: false,
      addLeadModal: false,
      creditpasswordOpenModal: false,
      followUpModal: false,
      fieldsUser: {},
      errorsUpdate: {},
      AddBalanceModal: false,
      DeductBalanceModal: false,
      show: false,
      balance: '',
      offset: 0,
      size: 12,
      pageNo: this.props.match.params.pageNo ? this.props.match.params.pageNo : 1,
      keyWord: '',
      status: "NEW",
      userIdCustom: "",
      updatePwdformData: {
        "id": "",
        "password": ""
      }
    }
  }
  componentDidMount() {

    console.log("pageNoooooooooooooooooooooooooooooo", this.props.match.params.pageNo);

    let userIdCustom = JSON.parse(localStorage.getItem('userIdCustom'));

    this.setState({ userIdCustom: userIdCustom, pageNo: this.props.match.params.pageNo })


    let { pageNo, keyWord } = this.props.match.params
    if (keyWord) {
      this.nameInput.focus();
    }

    let reqData = {
      "userIdCustom": userIdCustom ? userIdCustom : '',
      "keyWord": keyWord ? keyWord : '',
      "pageNo": pageNo ? pageNo : this.state.pageNo,
      "size": this.state.size,
      "sortOrder": "",
      // "status": this.state.status,
      "status": this.props.match.params.status.toUpperCase(),
    }
    this.props.dispatch(userActions.getLeadList(reqData));
  }

  static getDerivedStateFromProps(nextProps, prevState) {
    if (nextProps.users.addUserSuccess) {
      // this.multiselectRef.current.resetSelectedValues();
      // this.multiselectRefUser.current.resetSelectedValues();
      return {
        ...nextProps,
        selectedUser: [],
        selectedCategory: [],
        selectedCategory: {},
        fieldsLeadUpdate: {},
        fieldsUserPasswordUpdate: {},
        errorsUpdateLead: {},
        fieldsLead: {
          "calenderDate": moment(new Date()).format("YYYY-MM-DD")
        },
        errorsLead: {},
        errorsUpdatePassword: {},
        updateLeadModal: false,
        creditpasswordOpenModal: false,
        addLeadModal: false,
        addQuoteModal: false,
        followUpModal: false,
        fieldsUser: {},
        errorsUpdateLeadAdd: {},
        errorsUpdate: {},
        AddBalanceModal: false,
        DeductBalanceModal: false,
        balance: '',
        idParam: '',
        fieldsUserdeduct: '',
        fieldsFollowUp: {
          "dateAndTimeValue": dayjs().hour(10).minute(0)
        },
        selectedValue: []
      }
    } else {
      return {
        ...nextProps,

      }
    }
  }


  onSelect = (selectedList, selectedItem) => {
    this.setState({ selectedCategory: selectedList });
  }

  onRemove = (selectedList, removedItem) => {
    console.log('selectedList', selectedList);
    console.log('removedItem', removedItem);
    this.setState({ selectedCategory: selectedList });
  }

  onSelectUpdate = (selectedList, selectedItem) => {
    this.setState({ updateSelectedCategory: selectedList });
  }

  onRemoveUpdate = (selectedList, removedItem) => {
    console.log('selectedList', selectedList);
    console.log('removedItem', removedItem);
    this.setState({ updateSelectedCategory: selectedList });
  }

  onUserSelect = (selectedList, selectedItem) => {
    this.setState({ selectedUser: selectedList });
  }

  onUserRemove = (selectedList, removedItem) => {
    console.log('selectedList', selectedList);
    console.log('removedItem', removedItem);
    this.setState({ selectedUser: selectedList });
  }

  onUserSelectUpdate = (selectedList, selectedItem) => {
    this.setState({ updateSelectedUser: selectedList });
  }

  onUserRemoveUpdate = (selectedList, removedItem) => {
    console.log('selectedList', selectedList);
    console.log('removedItem', removedItem);
    this.setState({ updateSelectedUser: selectedList });
  }

  handlePageClick1 = (data) => {

    console.log("data  ", data);
    let offset = Math.ceil(data.selected * this.state.size);
    this.setState({ offset: offset, pageNo: data.selected + 1 });
    let datatemp = {
      "userIdCustom": this.state.userIdCustom,
      "keyWord": this.state.keyWord,
      "pageNo": Number(data.selected) + 1,
      "size": this.state.size,
      "status": this.props.match.params.status.toUpperCase(),
    }
    this.props.history.push("/app/"+this.props.match.params.status+"/Lead/" + (Number(data.selected) + 1));
    this.props.dispatch(userActions.getLeadList(datatemp));
  }
  componentDidUpdate(prevProps) {
    // Update the state when the URL parameter changes
    if (prevProps.match.params.pageNo !== this.props.match.params.pageNo) {
      this.setState({
        pageNo: Number(this.props.match.params.pageNo),
        keyWord: this.props.match.params.keyWord,
      });
    }
  }

  // handlePageClick = (data) => {
  //   this.props.history.push(`/app/${this.props.match.params.status}/Lead/${data}`);
  // }

  handleSearch = (event) => {
    event.preventDefault();
    // this.props.match.params.pageNo

    let { value } = event.target;
    if (this.props.match.params.pageNo != 1) {
      this.props.history.push(`/app/${this.props.match.params.status}/Lead/1/${value}`);
    } else {
      this.props.history.push(`/app/${this.props.match.params.status}/Lead/1/${value}`);
    }
    this.setState({ keyWord: value, offset: 0 });
    let data = {
      "userIdCustom": this.state.userIdCustom,
      "keyWord": value,
      "pageNo": this.props.match.params.pageNo,
      "size": this.state.size,
      "status": this.props.match.params.status.toUpperCase(),
    }
    this.props.dispatch(userActions.getLeadList(data));
  }

  disableLead = (data) => {
    let datatemp = {
      "id": data.id,
    }
    let paginationdata = {
      "userIdCustom": this.state.userIdCustom,
      "keyWord": "",
      "pageNo": this.state.pageNo,
      "size": this.state.size,
      "status": this.props.match.params.status.toUpperCase(),
    }
    confirmAlert({


      title: 'Confirm to change status Lead?',
      message: `Are you sure to change status of ${data.name} lead?`,
      buttons: [
        {
          label: 'Yes',
          onClick: () => this.props.dispatch(userActions.disableLead(datatemp, paginationdata))
        },
        {
          label: 'No'
        }
      ]
    });
  }

  deleteLead = (data) => {
    let datatemp = {
      "id": data.id,
    }

    let paginationData = {
      "userIdCustom": this.state.userIdCustom,
      "keyWord": this.state.keyWord,
      "pageNo": this.state.pageNo,
      "size": this.state.size
    }

    confirmAlert({

      title: 'Confirm to Delete?',
      message: `Are you sure to delete ${data.name} lead?`,
      buttons: [
        {
          label: 'Yes',
          onClick: () => this.props.dispatch(userActions.deleteLead(datatemp, paginationData))
        },
        {
          label: 'No'
        }
      ]
    });
  }

  handleOpenCreateModalMoreDetails = (data) => {
    this.props.history.push("/app/moreDetails/" + data.id)
  }

  handleMoreDetailsHideModal = () => {
    this.setState({ moreDetailsCreateModal: false });
  }

  handleShowFollowUpModal = (data) => {
    let reqData = {
      "leadId": data.id,
      "keyWord": this.state.keyWord,
      // "pageNo": this.state.pageNo,
      // "size": this.state.size
    }

    this.props.dispatch(userActions.getFollowUpListByLeadId(reqData))
    this.setState({ showFollowUpModal: true });
  }

  handleHideFollowUpModal = () => {
    this.setState({ showFollowUpModal: false });
  }

  handleUpdateLeadModal = (data) => {
    this.props.dispatch(userActions.getAllCategory());
    this.props.dispatch(userActions.getAllUser());
    console.log("datadatadatadatadatadatadatadata", data);
    this.setState({ updateLeadModal: true, fieldsLeadUpdate: data, updateSelectedCategory: data.categoryList, updateSelectedUser: data.assigneeList });
  }


  handleUpdateLeadModalClose = () => {
    this.setState({ updateLeadModal: false, updateSelectedCategory: [], updateSelectedUser: [] });
  }

  handleloginToThisAccountHideModal = () => {
    this.setState({ loginToThisAccountModal: false });
  }
  handleOpenloginToThisAccountModal = (data) => {
    // console.log("data loginToThisAccountloginToThisAccountloginToThisAccount....", data);
    let req = {
      "id": data.id
    }
    this.props.dispatch(userActions.loginToThisAccount(req));
    this.setState({ loginToThisAccountModal: true });
  }
  handleAddUserHideModal = () => {
    this.setState({ addQuoteModal: false });
    // this.setState({ appsettingUpdateModal: false });
  }

  handleOpenCreateModal = () => {
    // console.log("clicked");
    this.setState({ addQuoteModal: true });
  }
  inputAddUserChange = (e) => {
    e.preventDefault();
    let { name, value } = e.target;
    let fieldsLead = this.state.fieldsLead;
    let errorsLead = this.state.errorsLead;
    fieldsLead[name] = value;
    console.log(name, value);
    errorsLead[name] = "";
    this.setState({ fieldsLead, errorsLead });
  }

  handleMobileNumber = (e) => {
    let { name, value } = e.target;

    const trimmedValue = value.replace(/\s+/g, '').trim();
    let fieldsLead = this.state.fieldsLead;
    let errorsLead = this.state.errorsLead;
    fieldsLead[name] = trimmedValue;
    errorsLead[name] = "";
    // console.log(name, value);
    this.setState({ fieldsLead, errorsLead });
  }

  // inputStatusChange = (e) => {
  //   e.preventDefault();
  //   let { name, value } = e.target;
  //   let fieldsLead = this.state.fieldsLead;
  //   let errorsLead = this.state.errorsLead;
  //   fieldsLead[name] = value;
  //   errorsLead[name] = "";
  //   this.setState({ fieldsLead, errorsLead });

  //   let reqData = {
  //     "keyWord": this.state.keyWord,
  //     "pageNo": this.state.pageNo,
  //     "size": this.state.size,
  //     "status": value,
  //   }
  //   this.props.dispatch(userActions.getLeadList(reqData));
  // }

  inputChangeUpdateUser = (e) => {
    e.preventDefault();
    let { name, value } = e.target;
    let fieldsLeadUpdate = this.state.fieldsLeadUpdate;
    let errorsUpdateLead = this.state.errorsUpdateLead;
    fieldsLeadUpdate[name] = value;
    errorsUpdateLead[name] = "";
    console.log(name, value);
    this.setState({ fieldsLeadUpdate, errorsUpdateLead });
  }

  inputChangeFollowUp = (e) => {
    e.preventDefault();
    let { name, value } = e.target;
    let fieldsFollowUp = this.state.fieldsFollowUp;
    let errorsUpdateLead = this.state.errorsUpdateLead;
    fieldsFollowUp[name] = value;
    errorsUpdateLead[name] = "";
    console.log(name, value);
    this.setState({ fieldsFollowUp, errorsUpdateLead });
  }

  setDateAndTimeValue = (event) => {

    //   console.log('eventevent', event);
    //   let dateAndTimeValue = this.state.dateAndTimeValue;
    //   dateAndTimeValue = { moment(new Date(value)).format("YYYY-MM-DD HH:mm")
    // }
    this.setState({ dateAndTimeValue: event });
  }

  handleDateChange = (newValue) => {
    let fieldsFollowUp = this.state.fieldsFollowUp;
    fieldsFollowUp["dateAndTimeValue"] = newValue

    this.setState({ fieldsFollowUp });
  };

  inputChangeUpdatePasswordUser = (e) => {
    e.preventDefault();
    console.log("1111111111111", e.target.value);
    let { name, value } = e.target;
    let fieldsUserPasswordUpdate = this.state.fieldsUserPasswordUpdate;
    let errorsUpdatePassword = this.state.errorsUpdatePassword;
    fieldsUserPasswordUpdate[name] = value;
    errorsUpdatePassword[name] = "";
    console.log(name, value);
    this.setState({ fieldsUserPasswordUpdate, errorsUpdatePassword });
  }


  createLeadSubmit = () => {
    // let { users } = this.props;
    // let { filesDetails } = users;
    if (this.handleValidationAddUser()) {
      let selectedCategoryData = this.state.selectedCategory && this.state.selectedCategory.length > 0 ?
        this.state.selectedCategory.map((element) => (element.id)) : null

      let selectedUserData = this.state.selectedUser && this.state.selectedUser.length > 0 ?
        this.state.selectedUser.map((element) => (element.id)) : null
      let reqData = {
        "name": this.state.fieldsLead.name,
        "email": this.state.fieldsLead && this.state.fieldsLead.email ? this.state.fieldsLead.email : null,
        "mobNo": this.state.fieldsLead && this.state.fieldsLead.mobNo ? this.state.fieldsLead.mobNo : null,
        "calenderDate": this.state.fieldsLead.calenderDate,
        "categoryList": selectedCategoryData,
        "assigneeList": selectedUserData,
        "requirement": this.state.fieldsLead.requirement,
        "location": this.state.fieldsLead.location,
        "source": "this.state.fieldsLead.source",
        "companyName": this.state.fieldsLead.companyName,
      }
      // multiselectRef={this.multiselectRef}
      // multiselectRefUser={this.multiselectRefUser}
      this.props.dispatch(userActions.createLead(reqData, this.multiselectRef, this.multiselectRefUser));
      this.setState({
        fieldsLead: {
          "calenderDate": moment(new Date()).format("YYYY-MM-DD")
        },
      })
    }

  }

  handleFile = (event) => {
    console.log("handleFileevent", event);

    this.setState({ selectedFile: event.target.files[0] });
    if (event.target.files[0]) {
      this.setState({ selectedFile: null });
      this.props.dispatch(userActions.uploadImage(event.target.files[event.target.files.length - 1]));
    }
    else {
      console.log("No File To Upload!")
    }
  }

  handleValidationAddUser = () => {
    let fieldsLead = this.state.fieldsLead;
    let errorsLead = {};
    let formIsValid = true;

    //name
    if (!fieldsLead["name"] || fieldsLead["name"] === "") {
      formIsValid = false;
      errorsLead["name"] = "Name cannot be empty";
    }
    //Date
    if (!fieldsLead["calenderDate"] || fieldsLead["calenderDate"] === "") {
      formIsValid = false;
      errorsLead["calenderDate"] = "Date cannot be empty";
    }

    //requirement
    if (!fieldsLead["requirement"] || fieldsLead["requirement"] === "") {
      formIsValid = false;
      errorsLead["requirement"] = "Requirement cannot be empty";
    }
    //source
    // if (!fieldsLead["source"] || fieldsLead["source"] === "") {
    //   formIsValid = false;
    //   errorsLead["source"] = "Source cannot be empty";
    // }

    console.log('errorsUpdateLeaderrorsUpdateLeaderrorsUpdateLead', errorsLead);
    this.setState({ errorsLead: errorsLead });
    return formIsValid;
  }

  updateLead = () => {
    // let { users } = this.props;
    // let { filesDetails } = users;

    if (this.handleValidationUpdateUser()) {

      let selectedCategoryData = this.state.updateSelectedCategory && this.state.updateSelectedCategory.length > 0 ?
        this.state.updateSelectedCategory.map((element) => (element.id)) : null

      let selectedUserData = this.state.updateSelectedUser && this.state.updateSelectedUser.length > 0 ?
        this.state.updateSelectedUser.map((element) => (element._id)) : null

      let reqData = {
        "id": this.state.fieldsLeadUpdate.id,
        "name": this.state.fieldsLeadUpdate.name,
        "categoryList": selectedCategoryData,
        "assigneeList": selectedUserData,
        "calenderDate": this.state.fieldsLeadUpdate.calenderDate,
        "requirement": this.state.fieldsLeadUpdate.requirement,
        "mobNo": this.state.fieldsLeadUpdate.mobNo,
        "email": this.state.fieldsLeadUpdate.email,
        "source": this.state.fieldsLeadUpdate.source,
        "location": this.state.fieldsLeadUpdate.location,
        "companyName": this.state.fieldsLeadUpdate.companyName,
        "status": this.state.fieldsLeadUpdate.status,
      }
      let paginationData = {
        "keyWord": this.state.keyWord,
        "pageNo": this.state.pageNo,
        "size": this.state.size,
        "status": this.props.match.params.status.toUpperCase(),
      }
      this.props.dispatch(userActions.updateLead(reqData, paginationData));

      this.setState({ fieldsLeadUpdate: {} })
    }
  }

  createFollowUp = () => {
    if (this.handleValidationComment()) {
      let reqData = {
        "leadId": this.state.fieldsFollowUp.id,
        "comment": this.state.fieldsFollowUp.comment,
        "reminderDate": this.state.fieldsFollowUp.dateAndTimeValue
      }

      let paginationData = {
        "keyWord": this.state.keyWord,
        "pageNo": this.state.pageNo,
        "size": this.state.size,
        "status": this.props.match.params.status.toUpperCase(),
      }
      this.props.dispatch(userActions.createFollowUpLead(reqData, paginationData));
      this.setState({ fieldsFollowUp: {} })
    }
  }

  handleValidationUpdateUser = () => {
    let fieldsLeadUpdate = this.state.fieldsLeadUpdate;
    let errorsUpdateLead = {};
    let formIsValid = true;

    //name
    if (!fieldsLeadUpdate["name"] || fieldsLeadUpdate["name"] === "") {
      formIsValid = false;
      errorsUpdateLead["name"] = "Name cannot be empty";
    }

    //calenderDate
    if (!fieldsLeadUpdate["calenderDate"] || fieldsLeadUpdate["calenderDate"] === "") {
      formIsValid = false;
      errorsUpdateLead["calenderDate"] = "Date cannot be empty";
    }
    //requirement
    if (!fieldsLeadUpdate["requirement"] || fieldsLeadUpdate["requirement"] === "") {
      formIsValid = false;
      errorsUpdateLead["requirement"] = "Requirement cannot be empty";
    }
    // //source
    // if (!fieldsLeadUpdate["source"] || fieldsLeadUpdate["source"] === "") {
    //   formIsValid = false;
    //   errorsUpdateLead["source"] = "Source cannot be empty";
    // }
    console.log("errorsUpdateLeaderrorsUpdateLeaderrorsUpdateLead", errorsUpdateLead);
    this.setState({ errorsUpdateLead: errorsUpdateLead });
    return formIsValid;
  }

  handleValidationComment = () => {
    let fieldsFollowUp = this.state.fieldsFollowUp;
    let errorsFollowUp = {};
    let formIsValid = true;

    //comment
    if (!fieldsFollowUp["comment"] || fieldsFollowUp["comment"] === "") {
      formIsValid = false;
      errorsFollowUp["comment"] = "Comment cannot be empty";
    }

    console.log("errorsFollowUperrorsFollowUperrorsFollowUp", errorsFollowUp);
    this.setState({ errorsFollowUp: errorsFollowUp });
    return formIsValid;
  }

  handleAddLeadModal = () => {
    this.props.dispatch(userActions.getAllCategory());
    this.props.dispatch(userActions.getAllUser());

    this.setState({ addLeadModal: true, })
  }

  handleAddFollowUpModal = (data) => {
    this.setState({
      followUpModal: true,
      show: true,
      fieldsFollowUp: { ...data, dateAndTimeValue: dayjs().hour(10).minute(0) }
    })
  }

  handleFollowUpHideModal = () => {
    this.setState({
      followUpModal: false,
      // fieldsFollowUp: {}
      fieldsFollowUp: {
        // dateAndTimeValue: moment(new Date()).format("YYYY-MM-DD HH:mm")
        dateAndTimeValue: dayjs().hour(10).minute(0)
      },
    }
    )
  }

  handleAddLeadModalClose = () => {
    this.multiselectRef.current.resetSelectedValues();
    this.multiselectRefUser.current.resetSelectedValues();
    this.setState({
      addLeadModal: false,
      // selectedCategory: [], selectedUser: [],
      selectedValue: [],
      fieldsLead: {
        calenderDate: moment(new Date()).format("YYYY-MM-DD")
      },
    })
  }

  handleSelectedTag = (selectedTag) => {
    console.log("selectedselectedselected  ", selectedTag);
    this.setState({ selectedTag: selectedTag });
  };

  handleGoBack = () => {
    this.props.history.goBack();
  };

  copyCodeToClipboard = (data) => {
    navigator.clipboard.writeText(data)
    this.props.dispatch(alertActions.success("Copied!"));
  }

  handleCalender = () => {
    this.setState({ show: false, fieldsFollowUp: { ...this.state.fieldsFollowUp, dateAndTimeValue: "" } });
  };

  componentDidUpdate(prevProps) {
    // Update the state when the URL parameter changes
    if (prevProps.match.params.pageNo !== this.props.match.params.pageNo) {
      let offset = Math.ceil(this.props.match.params.pageNo * 2);
      this.setState({
        selectedPage: parseInt(this.props.match.params.pageNo, 10) - 1 || 0,
        offset: offset
      });
    }
  }

  handlePageClick = (data) => {

    const selectedPage = data.selected;
    // Update the URL with the new page number
    let { keyWord } = this.props.match.params
    if (keyWord) {
      this.props.history.push(`/app/${this.props.match.params.status}/Lead/${selectedPage + 1}/${keyWord}`);
    } else {
      this.props.history.push(`/app/${this.props.match.params.status}/Lead/${selectedPage + 1}`);
    }

    // console.log("this.state.keyWord  ",this.state.keyWord);
    // this.props.history.push(`/app/new/Lead/${selectedPage + 1}/${this.state.keyWord}`);
    // this.props.history.push("/app/new/Lead/" + (Number(data.selected) + 1));
    // Update the state with the new selected page
    // let offset = Math.ceil(selectedPage * this.state.size);
    this.setState({ selectedPage });
  };



  render() {

    let { users } = this.props;
    let { filesDetails, leadItems, leadTotal, loading, getAllCategory, getAllUser, followUpItems, followUpTotal } = users;
    let { fieldsLead } = this.state;

    // console.log("Render____________", keyWord);
    let { keyWord } = this.props.match.params
    // const totalItems = 26; // Replace with your actual data count
    // const itemsPerPage = 12;
    // const totalPages = Math.ceil(leadTotal / itemsPerPage);

    return (

      <>
        {/* <div>
          <LoadingOverlay
            active={loading}
            className="temp001"
            spinner
            text='Please wait...' />
        </div> */}

        <div className="flex flex-col flex-1 overflow-hidden overflow-y-auto">
          <main className="relative flex-1 ">
            <div className="p-3 2xl:p-10 sm:p-5">
              <div className="mx-auto max-w-screen-3xl ">
                {/* Transaction Section */}
                <section className="p-6 space-y-6 bg-white border rounded-md">

                  <div className="flex flex-wrap items-center justify-between w-full ">
                    <div className="flex space-x-6">
                      <div onClick={this.handleGoBack} className='p-1 text-gray-600 border border-gray-400 rounded-full cursor-pointer hover:bg-blue-400 hover:border-blue-400 hover:text-white'><BiArrowBack className='w-6 h-6' /></div>
                      <h3 className="font-medium text-xl text-[#3D405B] whitespace-nowrap capitalize">{this.props.match.params.status} Lead List</h3>
                    </div>
                    <div className='flex space-x-6 '>
                      <form action="#" method="GET"  >
                        <label htmlFor="mobile-search" className="sr-only">Search</label>
                        <div className="relative">
                          <div className="absolute inset-y-0 left-0 flex items-center pl-3 pointer-events-none">
                            <BiSearch style={{ fontSize: '1.5rem' }} className="text-gray-500" />
                          </div>
                          <input
                            ref={(input) => { this.nameInput = input; }}
                            value={keyWord} type="text" name="email" 
                            id="mobile-search" 
                            className="bg-gray-50 border border-gray-300 text-gray-900 text-sm rounded-lg  focus:ring-cyan-600 block w-full pl-10 p-2.5" placeholder="Search" onChange={this.handleSearch}  />
                        </div>
                      </form>

                      {this.props.match.params.status && this.props.match.params.status === "new" ?
                        <>
                          <button className="flex items-center p-2 text-sm font-medium text-white capitalize bg-blue-500 rounded-md whitespace-nowrap" onClick={() => this.handleAddLeadModal()}><MdAdd style={{ fontSize: "1.5rem" }} className="mr-1.5" /> Add Lead </button>
                        </> : null
                      }
                    </div>
                  </div>
                  {/* <div className='w-full flex justify-start'>
                    <div className="w-48">
                      <label className="block text-xs font-medium text-gray-500 md:text-left" for="username">Select Status :</label>
                      <select id="status" name="status" className="w-full p-2 mt-1 text-sm border border-gray-300 rounded-md focus:outline-none focus:ring-2 ring-gray-500"
                        value={fieldsLead && fieldsLead.status ? fieldsLead.status : null} onChange={this.inputStatusChange}>
                        <option value="NEW">NEW</option>
                        <option value="CONTACTED">CONTACTED</option>
                        <option value="QUALIFIED">QUALIFIED</option>
                        <option value="CONVERTED">CONVERTED</option>
                        <option value="LOST">LOST</option>
                      </select>
                    </div>
                  </div> */}
                  <div className="pb-2 mt-4 overflow-hidden rounded-lg">
                    <div className="max-w-full overflow-x-auto">
                      <div className="inline-block min-w-full ">
                        <div className="overflow-x-auto">
                          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-4">
                            {leadItems && leadItems.length > 0 ?
                              leadItems.map((element, index) => (<React.Fragment key={element.id}>
                                <div key={element.id} className="bg-gray-100 text-black rounded-md border border-gray-200">
                                  <div className='bg-blue-500 text-white flex justify-between items-center rounded-t-md p-3'>
                                    <div className="text-base lg:text-lg font-semibold">{Number(((this.state.pageNo - 1 | 0)) * this.state.size + index + 1)}</div>
                                    <div className="text-base lg:text-lg font-semibold cursor-pointer relative" title={element && element.name ? element.name : ""}
                                      onClick={() => this.handleOpenCreateModalMoreDetails(element)}>
                                      {/* {element && element.name.length > 25 ? element.name.substring(0, 25) + "..." : element.name} */}
                                      {element && element.name ? element.name : ""}
                                    </div>
                                    <div className="flex justify-center space-x-2 text-black">
                                      <div class="rounded-full font-medium bg-blue-100 cursor-pointer p-2" onClick={() => this.handleAddFollowUpModal(element)}>
                                        <GrAddCircle size={20} />
                                      </div>
                                      <div class="rounded-full font-medium bg-blue-100 cursor-pointer p-2" onClick={() => this.handleShowFollowUpModal(element)}>
                                        <FaList size={20} />
                                      </div>
                                      <div class="rounded-full font-medium bg-blue-100 cursor-pointer p-2" onClick={() => this.handleOpenCreateModalMoreDetails(element)}>
                                        <BiDetail size={20} />
                                      </div>
                                      <div class="rounded-full font-medium bg-blue-100 cursor-pointer p-2" onClick={() => this.handleUpdateLeadModal(element)}>
                                        <MdOutlineEdit size={20} />
                                      </div>
                                    </div>
                                  </div>
                                  <div className="px-6 py-3 text-sm">{element && element.email ? element.email : "-"}</div>
                                  <div className="px-6 py-3 text-sm flex justify-start space-x-2">
                                    <span>{element && element.mobNo ? element.mobNo : "-"}</span>
                                    <FaRegCopy size={18} className='cursor-pointer ' onClick={() => this.copyCodeToClipboard(`${element && element.mobNo ? element.mobNo : "-"}`)} />
                                  </div>
                                  <div className="px-6 py-3 text-sm" title={element && element.requirement ? element.requirement : "-"}>
                                    {element && element.requirement.length > 100 ? element.requirement.substring(0, 100) + "..." : element.requirement}</div>
                                  <div className="px-6 py-3 text-sm">{element && element.status ? element.status : "-"} </div>
                                  <div className="px-6 py-3">{element && element.location ? element.location : "-"}</div>
                                  <div className="px-6 py-3 text-sm">
                                    {moment(new Date(parseInt(element.createdAt))).utcOffset("+05:30").format("DD-MM-YYYY (HH:mm A)")}
                                  </div>
                                </div>
                              </React.Fragment>))
                              : (<div className="bg-white bg-opacity-5 " >
                                <div className="col-span-3 px-6 py-3 text-sm font-medium text-gray-500 whitespace-nowrap">Not Found</div>
                              </div>)}
                          </div>
                        </div>
                      </div>
                    </div>
                    {/* 
                    {isMobile ?
                      <nav className="relative z-0 flex justify-end mt-5 w-76">
                        {leadTotal && leadTotal > 10 ?
                          <ReactPaginate
                            previousLabel={'Prev'}
                            nextLabel={'Next'}
                            breakLabel={'...'}
                            breakClassName={'break-me'}
                            pageCount={leadTotal / this.state.size}
                            marginPagesDisplayed={1}
                            pageRangeDisplayed={1}
                            onPageChange={this.handlePageClick}
                            containerClassName={'pagination'}
                            pageClassName={'page-cls'}
                            activeClassName={'active'}
                          />
                          : null}
                      </nav> : <nav className="relative z-0 flex justify-end mt-5 w-76">
                        {leadTotal && leadTotal > 10 ?
                          <ReactPaginate
                            previousLabel={'Previous'}
                            nextLabel={'Next'}
                            breakLabel={'...'}
                            breakClassName={'break-me'}
                            pageCount={leadTotal / this.state.size}
                            marginPagesDisplayed={3}
                            pageRangeDisplayed={3}
                            // forcePage={this.props.match.params.pageNo}
                            onPageChange={this.handlePageClick}
                            containerClassName={'pagination'}
                            pageClassName={'page-cls'}
                            activeClassName={'active'}
                          />
                          : null}
                      </nav>
                    } */}
                    <nav className="relative z-0 flex justify-end mt-5 w-76">
                      {leadTotal && leadTotal > 10 ?
                        <ReactPaginate
                          pageCount={Math.ceil(leadTotal / this.state.size)} // Replace with the actual number of pages
                          pageRangeDisplayed={2}
                          marginPagesDisplayed={2}
                          onPageChange={this.handlePageClick}
                          forcePage={this.state.selectedPage}
                          containerClassName={'pagination'}
                          activeClassName={'active'}
                        /> : null}
                    </nav>
                  </div>
                </section>
              </div>
            </div>
          </main>
        </div>

        <DialogExample />
        <AddLeadModal
          multiselectRef={this.multiselectRef}
          multiselectRefUser={this.multiselectRefUser}
          handleAddLeadModalClose={this.handleAddLeadModalClose}
          getAllCategory={getAllCategory}
          getAllUser={getAllUser}
          options={getAllCategory}
          selectedValue={this.state.selectedValue}
          onSelect={this.onSelect}
          onRemove={this.onRemove}
          onUserSelect={this.onUserSelect}
          onUserRemove={this.onUserRemove}
          handleSelectedTag={this.handleSelectedTag}
          selectedTag={this.state.selectedTag}
          addLeadModal={this.state.addLeadModal}
          fieldsLead={this.state.fieldsLead}
          errorsLead={this.state.errorsLead}
          inputAddUserChange={this.inputAddUserChange}
          handleMobileNumber={this.handleMobileNumber}
          // handlePaste={this.handlePaste}
          createLeadSubmit={this.createLeadSubmit}
        />

        <UpdateLeadModal
          getAllCategory={getAllCategory}
          getAllUser={getAllUser}
          updateSelectedUser={this.state.updateSelectedUser}
          updateSelectedCategory={this.state.updateSelectedCategory}
          onSelectUpdate={this.onSelectUpdate}
          onRemoveUpdate={this.onRemoveUpdate}
          onUserSelectUpdate={this.onUserSelectUpdate}
          onUserRemoveUpdate={this.onUserRemoveUpdate}
          updateLeadModal={this.state.updateLeadModal}
          fieldsLeadUpdate={this.state.fieldsLeadUpdate}
          errorsUpdateLead={this.state.errorsUpdateLead}
          inputChangeUpdateUser={this.inputChangeUpdateUser}
          updateLead={this.updateLead}
          handleUpdateLeadModalClose={this.handleUpdateLeadModalClose}
        />

        <AddFollowUpModal
          fieldsFollowUp={this.state.fieldsFollowUp}
          errorsFollowUp={this.state.errorsFollowUp}
          inputChangeFollowUp={this.inputChangeFollowUp}
          createFollowUp={this.createFollowUp}
          handleFollowUpHideModal={this.handleFollowUpHideModal}
          followUpModal={this.state.followUpModal}
          show={this.state.show}
          handleDateChange={this.handleDateChange}
          handleCalender={this.handleCalender}
        />

        <ShowFollowUpModal
          handleHideFollowUpModal={this.handleHideFollowUpModal}
          showFollowUpModal={this.state.showFollowUpModal}
          followUpItems={followUpItems}
          followUpTotal={followUpTotal}
          offset={this.state.offset}
        />
      </>

    );
  }
}
function mapStateToProps(state) {
  const { users } = state;
  return {
    users
  };
}
export default connect(mapStateToProps)(Lead);
